import { useState, useEffect } from "react";

export default function useOnline() {
	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		function offlineHandler() {
			setIsOnline(navigator.onLine);
		}

		window.addEventListener("online", offlineHandler);
		window.addEventListener("offline", offlineHandler);

		return () => {
			window.removeEventListener("online", offlineHandler);
			window.removeEventListener("offline", offlineHandler);
		};
	}, []);

	return isOnline;
}
